const el = {
  common: {
    save: 'Αποθήκευση',
    cancel: 'Ακύρωση',
    confirm: 'Επιβεβαίωση',
    delete: 'Διαγραφή',
    cancelDelete: 'Ακύρωση διαγραφής',
    edit: 'Επεξεργασία',
    add: 'Προσθήκη',
    create: 'Δημιουργία',
    back: 'Πίσω',
    search: 'Αναζήτηση',
    remove: 'Αφαίρεση',
    close: 'Κλείσιμο',
    closeMenu: 'Κλείσιμο μενού',
    loading: 'Φόρτωση...',
    somethingWentWrong: 'Κάτι πήγε στραβά',
    yes: 'Ναι',
    no: 'Όχι',
    required: 'Υποχρεωτικό',
    noResults: 'Δεν υπάρχουν αποτελέσματα',
    home: 'Αρχική',
    link: 'Σύνδεση',
    showPassword: 'Εμφάνιση κωδικού',
    hidePassword: 'Απόκρυψη κωδικού',
  },
  serviceUnavailable: {
    title: 'Η υπηρεσία δεν είναι διαθέσιμη',
    message: 'Αυτή τη στιγμή δεν είναι δυνατή η σύνδεση με την υπηρεσία.<br/>Παρακαλούμε δοκιμάστε ξανά σε λίγο.',
    retry: 'Δοκιμάστε ξανά',
    retryCooldown: 'Δοκιμάστε ξανά ({{seconds}})',
  },
  header: {
    welcome: 'Καλώς ήρθες,',
    logout: 'Αποσύνδεση',
    language: 'Γλώσσα',
    languageGreek: 'Ελληνικά',
    languageEnglish: 'English',
  },
  branchSelector: {
    selectBranchTitle: 'Επιλογή υποκαταστήματος',
    selectBranchLabel: 'Επιλογή υποκαταστήματος:',
    save: 'Αποθήκευση',
  },
  menu: {
    overview: 'Επισκόπηση',
    contacts: 'Επαφές',
    leads: 'Leads',
    companies: 'Εταιρείες',
    orders: 'Παραγγελίες',
    employees: 'Υπάλληλοι',
    bookings: 'Ημερολόγιο',
    services: 'Υπηρεσίες',
    settings: 'Ρυθμίσεις',
    statistics: 'Στατιστικά',
  },
  breadcrumbs: {
    contacts: 'Επαφές',
    services: 'Υπηρεσίες',
    employees: 'Υπάλληλοι',
    orders: 'Παραγγελίες',
    settings: 'Ρυθμίσεις',
    employeePlan: 'Ημερολόγιο',
  },
  enums: {
    companyType: {
      IKE: 'Ιδιωτική κεφαλαιουχική εταιρεία',
      EPE: 'Εταιρεία περιορισμένης ευθύνης',
      AE: 'Ανώνυμη εταιρεία',
      OE: 'Ομόρρυθμη εταιρεία',
      EE: 'Ετερόρρυθμη εταιρεία',
      SOLE_PROPRIETORSHIP: 'Ατομική επιχείρηση',
    },
    companyRole: {
      OWNER: 'Ιδιοκτήτης',
    },
    bookingStatus: {
      ACTIVE: 'Σε Ισχύ',
      COMPLETED: 'Ολοκληρωμένο',
      CANCELLED: 'Ακυρωμένο',
      NO_SHOW: 'Χωρίς προσέλευση',
      PENDING: 'Μη επιβεβαιωμένο',
    },
    communicationStatus: {
      DRAFT: 'Πρόχειρη',
      IN_PROGRESS: 'Σε Εξέλιξη',
      RECALL: 'Recall',
      REJECTED: 'Απορριφθείσα',
      COMPLETED: 'Ολοκληρωμένη',
    },
    orderStatus: {
      DRAFT: 'Πρόχειρη',
      SUBMITTED: 'Υποβληθείσα',
      UNDER_NEGOTIATION: 'Υπό Διαπραγμάτευση',
      ACCEPTED: 'Αποδεκτή',
      REJECTED: 'Απορριφθείσα',
      CANCELLED: 'Ακυρωμένη',
      EXPIRED: 'Ληγμένη',
      PENDING: 'Σε Εκκρεμότητα',
      PROCESSING: 'Σε Επεξεργασία',
      COMPLETED: 'Ολοκληρωμένη',
      ON_HOLD: 'Σε Αναμονή',
      FAILED: 'Απέτυχε',
      SHIPPED: 'Απεσταλμένη',
    },
    gender: {
      FEMALE: 'Γυναίκα',
      MALE: 'Άνδρας',
      OTHER: 'Άλλο',
      UNKNOWN: 'Άγνωστο',
    },
    dayOfWeek: {
      MONDAY: 'Δευτέρα',
      TUESDAY: 'Τρίτη',
      WEDNESDAY: 'Τετάρτη',
      THURSDAY: 'Πέμπτη',
      FRIDAY: 'Παρασκευή',
      SATURDAY: 'Σάββατο',
      SUNDAY: 'Κυριακή',
    },
    paymentMethod: {
      DOMESTIC_BUSINESS_PAYMENT_ACCOUNT: 'Επαγ. Λογαριασμός Πληρωμών Ημεδαπής',
      FOREIGN_BUSINESS_PAYMENT_ACCOUNT: 'Επαγ. Λογαριασμός Πληρωμών Αλλοδαπής',
      CASH: 'Μετρητά',
      CHECK: 'Επιταγή',
      ON_CREDIT: 'Επί Πιστώσει',
    },
    country: {
      AT: 'Αυστρία',
      BE: 'Βέλγιο',
      BG: 'Βουλγαρία',
      HR: 'Κροατία',
      CY: 'Κύπρος',
      CZ: 'Τσεχία',
      DK: 'Δανία',
      EE: 'Εσθονία',
      FI: 'Φινλανδία',
      FR: 'Γαλλία',
      DE: 'Γερμανία',
      GR: 'Ελλάδα',
      HU: 'Ουγγαρία',
      IE: 'Ιρλανδία',
      IT: 'Ιταλία',
      LV: 'Λετονία',
      LT: 'Λιθουανία',
      LU: 'Λουξεμβούργο',
      MT: 'Μάλτα',
      NL: 'Ολλανδία',
      PL: 'Πολωνία',
      PT: 'Πορτογαλία',
      RO: 'Ρουμανία',
      SK: 'Σλοβακία',
      SI: 'Σλοβενία',
      ES: 'Ισπανία',
      SE: 'Σουηδία',
      GB: 'Ηνωμένο Βασίλειο',
    },
  },
  searchDialogs: {
    company: {
      titleNew: 'Σύνδεση εταιρείας',
      titleEdit: 'Ενημέρωση σύνδεσης επαφής-εταιρείας',
      companyLabel: 'Εταιρεία',
      roleLabel: 'Ρόλος',
      saveButton: 'Αποθήκευση',
      linkButton: 'Σύνδεση',
    },
    contact: {
      titleNew: 'Σύνδεση επαφής',
      titleEdit: 'Ενημέρωση σύνδεσης επαφής-εταιρείας',
      contactLabel: 'Επαφή',
      roleLabel: 'Ρόλος',
      saveButton: 'Αποθήκευση',
      linkButton: 'Σύνδεση',
    },
  },
  contacts: {
    listTitle: 'Επαφές',
    addContact: 'Δημιουργία επαφής',
    backToList: 'Λίστα επαφών',
    createTitle: 'Δημιουργία επαφής',
    select: 'Επιλέξτε',
    columns: {
      lastName: 'Επώνυμο',
      firstName: 'Όνομα',
      mobilePhone: 'Κινητό τηλέφωνο',
      additionalPhone: 'Σταθερό τηλέφωνο',
      email: 'Email',
      source: 'Πηγή',
      branch: 'Κατάστημα',
    },
    tooltips: {
      lead: 'Lead (έχει προσφορά/παραγγελία)',
      customer: 'Πελάτης (έχει ολοκληρωμένη παραγγελία)',
      mobileCheck: 'Έλεγχος Χρήσης Τηλεφωνικού Αριθμού σε Υφιστάμενες Επαφές',
    },
    search: {
      mobilePlaceholder: 'Όνομα, Επίθετο, Κινητό, Email',
    },
    sections: {
      basicInfo: 'Βασικές πληροφορίες',
      contactInfo: 'Στοιχεία επικοινωνίας',
      additionalInfo: 'Συμπληρωματικές πληροφορίες',
      linkedCompanies: 'Συνδεδεμένες εταιρείες',
    },
    fields: {
      mobilePhone: 'Κινητό τηλέφωνο',
      firstName: 'Όνομα',
      lastName: 'Επώνυμο',
      additionalPhone: 'Σταθερό τηλέφωνο',
      email: 'Email',
      facebook: 'Facebook',
      gender: 'Φύλο',
      occupation: 'Επάγγελμα',
      dateOfBirth: 'Γενέθλια',
      acquisitionSource: 'Πού μας βρήκατε',
      address: 'Διεύθυνση',
      branch: 'Κατάστημα Καταχώρησης',
      notes: 'Παρατηρήσεις',
    },
    snackbars: {
      saved: 'Η επαφή αποθηκεύτηκε επιτυχώς!',
      saveFailed: 'Η αποθήκευση της επαφής απέτυχε',
      notFound: 'Η επαφή δεν βρέθηκε',
      mobileCheckFailed: 'Κάτι πήγε στραβά κατά τον έλεγχο του κινητού',
      contactLinked: 'Η επαφή συνδέθηκε με την εταιρεία',
      contactUnlinked: 'Η επαφή αφαιρέθηκε από την εταιρεία',
    },
    validation: {
      mobileInUse:
        'Το κινητό τηλέφωνο χρησιμοποιείται ήδη από τις επαφές {{names}}. Μπορείτε να το χρησιμοποιήσετε ξανά με διαφορετικό όνομα, αλλά ΠΡΟΣΟΧΗ θα έχετε δύο ή περισσότερες επαφές με το ίδιο κινητό.',
      mobileRequired: 'Το κινητό είναι υποχρεωτικό',
      mobileInvalid: 'Το κινητό δεν είναι έγκυρο',
      firstNameRequired: 'Το όνομα είναι υποχρεωτικό',
      genderInvalid: 'Η τιμή που επιλέξατε δεν είναι μέσα στις επιτρεπτές τιμές.',
      additionalPhoneInvalid: 'Ο αριθμός σταθερού δεν είναι έγκυρος',
      emailInvalid: 'Η διεύθυνση email δεν είναι έγκυρη',
      facebookInvalid: 'Η διεύθυνση του προφίλ δεν είναι έγκυρη',
    },
    communication: {
      employeeRequired: 'Ο υπάλληλος είναι υποχρεωτικός',
      statusRequired: 'Η κατάσταση είναι υποχρεωτική',
      dateRequired: 'Η ημερομηνία είναι υποχρεωτική',
      reminderRequired: 'Η ημερομηνία υπενθύμισης είναι υποχρεωτική για Recall',
    },
    companiesSection: {
      linkCompany: 'Σύνδεση εταιρείας',
      columns: {
        legalName: 'Επωνυμία',
        type: 'Τύπος',
        roles: 'Ρόλοι',
      },
      unlink: {
        title: 'Αποσύνδεση από εταιρεία',
        content: 'Θέλετε να αποσυνδέσετε την επαφή από την εταιρεία {{companyName}}?',
        confirm: 'Αποσύνδεση',
      },
    },
    communications: {
      list: {
        title: 'Επικοινωνίες ({{count}})',
        newButton: 'Νέα επικοινωνία',
        columns: {
          date: 'Ημερομηνία',
          employee: 'Υπάλληλος',
          contact: 'Επαφή',
          status: 'Κατάσταση',
          notes: 'Σημειώσεις',
        },
        reminderTooltip: 'Υπενθύμιση: {{date}}',
        noRows: 'Δεν υπάρχουν επικοινωνίες',
        loadFailed: 'Σφάλμα κατά τη φόρτωση επικοινωνιών',
        deleted: 'Η επικοινωνία διαγράφηκε επιτυχώς',
        deleteFailed: 'Σφάλμα κατά τη διαγραφή της επικοινωνίας',
        deleteTitle: 'Διαγραφή επικοινωνίας',
        deleteContent: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την επικοινωνία;',
        deleteConfirm: 'Διαγραφή',
      },
      modal: {
        createTitle: 'Νέα επικοινωνία',
        editTitle: 'Επεξεργασία επικοινωνίας',
        fields: {
          employee: 'Υπάλληλος',
          date: 'Ημερομηνία',
          status: 'Κατάσταση',
          recallDateTime: 'Ημερομηνία & ώρα υπενθύμισης',
          notes: 'Σημειώσεις',
        },
        createSuccess: 'Η επικοινωνία δημιουργήθηκε επιτυχώς',
        updateSuccess: 'Η επικοινωνία ενημερώθηκε επιτυχώς',
        saveFailed: 'Σφάλμα κατά την αποθήκευση της επικοινωνίας',
        createButton: 'Δημιουργία',
        saveButton: 'Αποθήκευση',
        cancelButton: 'Ακύρωση',
      },
    },
  },
  leads: {
    listTitle: 'Leads',
    createOrder: 'Δημιουργία παραγγελίας',
    columns: {
      lastName: 'Επώνυμο',
      firstName: 'Όνομα',
      mobilePhone: 'Κινητό',
      email: 'Email',
      leadManager: 'Υπάλληλος (leader)',
      participants: 'Συμμετέχοντες',
      lastOrder: 'Τελευταία παραγγελία',
    },
    tooltips: {
      customer: 'Πελάτης (έχει ολοκληρωμένη παραγγελία)',
      viewOrder: 'Προβολή παραγγελίας',
    },
  },
  employees: {
    listTitle: 'Υπάλληλοι',
    addEmployee: 'Προσθήκη υπαλλήλου',
    availableSlots: 'Διαθέσιμες θέσεις: {{count}}',
    active: 'Ενεργός',
    inactive: 'Μη ενεργός',
    backToList: 'Λίστα Υπαλλήλων',
    createTitle: 'Προσθήκη υπαλλήλου',
    columns: {
      lastName: 'Επώνυμο',
      firstName: 'Όνομα',
      mobilePhone: 'Κινητό τηλέφωνο',
      email: 'Email',
      specialties: 'Ειδικότητες',
      status: 'Κατάσταση',
    },
    tabs: {
      basicInfo: 'Βασικές Πληροφορίες',
      employmentInfo: 'Στοιχεία εργασίας',
      schedule: 'Ωράριο υπαλλήλου',
      communications: 'Επικοινωνίες',
    },
    steps: {
      basicInfo: 'Βασικές Πληροφορίες',
      workInfo: 'Στοιχεία εργασίας',
    },
    fields: {
      firstName: 'Όνομα',
      lastName: 'Επώνυμο',
      email: 'Email',
      mobilePhone: 'Κινητό τηλέφωνο',
      taxIdentificationNumber: 'ΑΦΜ',
      taxOffice: 'ΔΟΥ',
      nationalInsuranceNumber: 'ΑΜΑ',
      iban: 'IBAN',
      bank: 'Τράπεζα',
      socialSecurityNumber: 'ΑΜΚΑ',
      additionalMobilePhone: '2ο κινητό τηλέφωνο',
      additionalPhone: 'Σταθερό τηλέφωνο',
      facebook: 'Facebook',
      serviceGroup: 'Ειδικότητα',
      contractualWorkWeekHours: 'Ώρες απασχόλησης',
      grossWage: 'Μεικτός μισθός',
      netWage: 'Καθαρός Μισθός',
      contractStart: 'Ημερομηνία έναρξης σύμβασης',
      contractEnd: 'Ημερομηνία λήξης σύμβασης',
    },
    placeholders: {
      fillIban: 'Συμπληρώστε το IBAN',
    },
    tooltips: {
      mobileCheck: 'Έλεγχος Χρήσης Τηλεφωνικού Αριθμού σε Υφιστάμενους Υπαλλήλους',
      contractEndAutoDeactivate: 'Αυτόματη Απενεργοποίηση Προσωπικού μετά τη Λήξη Σύμβασης',
      contractEndDeactivates: 'Μετά το πέρας της ημερομηνίας λήξης σύμβασης ο υπάλληλος γίνεται ανενεργός',
      edit: 'Επεξεργασία',
    },
    actions: {
      previous: 'Προηγούμενο',
      next: 'Επόμενο',
      check: 'Έλεγχος',
      continue: 'Συνέχεια',
      newContact: 'Νέα επαφή',
    },
    dialogs: {
      mobileCheck: {
        title: 'Έλεγχος κινητού τηλεφώνου',
        description: 'Ελέγχεις αν το κινητό τηλέφωνο που θέλεις να εισάγεις χρησιμοποιείται ήδη σε μια ή περισσότερες επαφές',
      },
      contactExists: {
        title: 'Επιλογή επαφής',
        usedBy: 'Το κινητό τηλέφωνο <b>{{phone}}</b> χρησιμοποιείται:',
        inEmployees: 'Στους παρακάτω εργαζομένους',
        inContacts: 'Στις παρακάτω επαφές',
        help: {
          title: 'Τι να πατήσω?',
          continue: '<b>Συνέχεια</b> για να γίνει προσυμπλήρωση στοιχείων.',
          newContact:
            '<b>Νέα επαφή</b> για να δημιουργήσετε επαφή με το παρόν κινητό και διαφορετικό όνομα. Προσοχή έτσι θα έχετε δύο ή περισσότερες επαφές με το ίδιο κινητό.',
          cancel: '<b>Ακύρωση</b> ώστε να εισάγετε νέο κινητό τηλέφωνο.',
        },
      },
    },
    snackbars: {
      saved: 'Ο υπάλληλος αποθηκεύτηκε επιτυχώς!',
      saveFailed: 'Η αποθήκευση του υπαλλήλου απέτυχε',
      notFound: 'Ο υπάλληλος δεν βρέθηκε',
      ibanCheckFailed: 'Κάτι πήγε στραβά κατά τον έλεγχο του IBAN',
      mobileCheckFailed: 'Κάτι πήγε στραβά κατά τον έλεγχο του κινητού',
    },
    validation: {
      ibanInvalidFormat: 'Το IBAN πρέπει να περιέχει μόνο λατινικούς χαρακτήρες και αριθμούς',
      ibanInvalid: 'Το IBAN δεν είναι έγκυρο',
      dateInvalid: 'Παρακαλώ εισάγετε έγκυρη ημερομηνία',
      dateRequired: 'Η ημερομηνία είναι υποχρεωτική',
      contractStartBeforeEnd: 'Η έναρξη σύμβασης πρέπει να προηγείται της λήξης',
      contractEndAfterStart: 'Η λήξη σύμβασης πρέπει να έπεται της αρχής',
      mobileRequired: 'Το κινητό είναι υποχρεωτικό',
      mobileInvalid: 'Το κινητό δεν είναι έγκυρο',
      firstNameRequired: 'Το όνομα είναι υποχρεωτικό',
      emailInvalid: 'Η διεύθυνση email δεν είναι έγκυρη',
      ssnInvalid: 'Το ΑΜΚΑ δεν είναι έγκυρο',
      ninInvalid: 'Το ΑΜΑ δεν είναι έγκυρο',
      tinInvalid: 'Το ΑΦΜ δεν είναι έγκυρο',
      additionalPhoneInvalid: 'Ο αριθμός σταθερού δεν είναι έγκυρος',
      phoneInUse: 'Ο αριθμός χρησιμοποιείται ήδη',
      numberInvalid: 'Παρακαλώ εισάγετε έναν έγκυρο αριθμό',
      hoursMin: 'Η ελάχιστη διάρκεια απασχόλησης είναι 1 ώρα',
      hoursMax: 'Η διάρκεια απασχόλησης δεν είναι έγκυρη',
      hoursRequired: 'Η διάρκεια απασχόλησης είναι υποχρεωτική',
      mobileInUse:
        'Το κινητό τηλέφωνο χρησιμοποιείται ήδη από τον υπάλληλο {{name}}. Μπορείτε να το χρησιμοποιήσετε ξανά με διαφορετικό όνομα, αλλά ΠΡΟΣΟΧΗ θα έχετε δύο ή περισσότερους υπαλλήλους με το ίδιο κινητό.',
    },
    schedule: {
      title: 'Πλάνο υπαλλήλου',
      sections: {
        current: 'Τρέχον πλάνο',
        future: 'Προγραμματισμένα πλάνα',
        past: 'Ιστορικό πλάνων',
        workHours: 'Ώρες εργασίας',
        breaks: 'Διάλειμμα',
        shift1: 'Ωράριο 1',
        shift2: 'Ωράριο 2',
      },
      empty: 'Δεν υπάρχει ενεργό πλάνο. Πατήστε "Νέο πλάνο" για να δημιουργήσετε ένα πλάνο.',
      fields: {
        title: 'Τίτλος:',
        titlePlaceholder: 'πχ. Μάιος 2025',
        startDate: 'Ημερομηνία έναρξης:',
        endDate: 'Ημερομηνία λήξης:',
        alternatingWeeks: 'Εναλλασσόμενα ωράρια',
      },
      columns: {
        name: 'Τίτλος',
        effectiveFrom: 'Ημερομηνία έναρξης',
        effectiveTo: 'Ημερομηνία λήξης',
      },
      currentItem: {
        startDate: 'Ημερομηνία έναρξης: <b>{{date}}</b>',
        endDate: 'Ημερομηνία λήξης: <b>{{date}}</b>',
      },
      actions: {
        planOverride: 'Έκτακτη τροποποίηση',
        newPlan: 'Νέο πλάνο',
        update: 'Ενημέρωση',
        addShift: 'Προσθήκη ωραρίου',
        addBreak: 'Προσθήκη διαλείμματος',
        editPlan: 'Τροποποίηση πλάνου',
        today: 'Σήμερα',
        saveAsDayOff: 'Αποθήκευση ως μη εργάσιμη',
      },
      snackbars: {
        created: 'Το πρόγραμμα αποθηκεύτηκε επιτυχώς!',
        updated: 'Το πρόγραμμα ενημερώθηκε επιτυχώς!',
        saveFailed: 'Η αποθήκευση του προγράμματος απέτυχε',
        overlap: 'Εντοπίστηκε αλληλοεπικάλυψη του προγράμματος με άλλο πρόγραμμα',
        fetchFailed: 'Κάτι πήγε στραβά.',
      },
      override: {
        title: 'Έκτακτη τροποποίηση',
        dateLabel: 'Ημερομηνία προς τροποποίηση:',
        dayOff: 'Η επιλεγμένη ημερομηνία είναι μη εργάσιμη για τον υπάλληλο.',
        tooltips: {
          addShift: 'Προσθήκη βάρδιας',
          deleteShift: 'Διαγραφή βάρδιας',
          addBreak: 'Προσθήκη διαλείμματος',
          deleteBreak: 'Διαγραφή διαλείμματος',
        },
        snackbars: {
          searchFailed: 'Η αναζήτηση της τροποποίησης απέτυχε',
          deleted: 'Η τροποποίηση διαγράφτηκε',
          deleteFailed: 'Η διαγραφή της τροποποίησης απέτυχε',
          saved: 'Η τροποποίηση αποθηκεύτηκε',
          saveFailed: 'Η αποθήκευση της τροποποίησης απέτυχε',
        },
        ergani: {
          sendButton: 'Αποστολή στην ΕΡΓΑΝΗ',
          sentChip: 'Απεστάλη στην ΕΡΓΑΝΗ',
          pendingChip: 'Εκκρεμεί αποστολή',
          snackbars: {
            sendSuccess: 'Η αποστολή στην ΕΡΓΑΝΗ ολοκληρώθηκε επιτυχώς',
            sendFailed: 'Η αποστολή στην ΕΡΓΑΝΗ απέτυχε',
            alreadySent: 'Η τροποποίηση έχει ήδη αποσταλεί στην ΕΡΓΑΝΗ',
          },
        },
      },
      validation: {
        startRequired: "Η ώρα 'από' είναι υποχρεωτικό πεδίο",
        endRequired: "Η ώρα 'εως' είναι υποχρεωτικό πεδίο",
        endAfterStart: "Η ώρα 'εως' πρέπει να είναι μεταγενέστερη της ώρας 'από'",
        nameRequired: 'Το όνομα του πλάνου είναι υποχρεωτικό',
        dateInvalid: 'Παρακαλώ εισάγετε έγκυρη ημερομηνία',
        dateRequired: 'Η ημερομηνία είναι υποχρεωτική',
        planStartBeforeEnd: 'Η έναρξη του πλάνου πρέπει να προηγείται της λήξης',
        planEndAfterStart: 'Η λήξη του πλάνου πρέπει να έπεται της αρχής',
      },
    },
    plan: {
      backToEdit: 'Επεξεργασία υπαλλήλου',
      notFound: 'Το πρόγραμμα δεν βρέθηκε',
      legend: {
        work: 'Εργάσιμες ώρες',
        break: 'Διαλείμματα',
        today: 'Τρέχουσα ημέρα',
      },
    },
  },
  services: {
    listTitle: 'Υπηρεσίες',
    addService: 'Δημιουργία υπηρεσίας',
    reorderTitle: 'Αλλαγή σειράς εμφάνισης',
    available: 'Διαθέσιμη',
    unavailable: 'Μη διαθέσιμη',
    active: 'Ενεργή',
    inactive: 'Ανενεργή',
    minute: 'λεπτό',
    minutes: 'λεπτά',
    cannotDisableLastActive: 'Δεν μπορεί να απενεργοποιηθεί η μοναδική ενεργή υπηρεσία της ειδικότητας',
    createTitle: 'Δημιουργία υπηρεσίας',
    backToList: 'Λίστα υπηρεσιών',
    columns: {
      name: 'Όνομα',
      code: 'Κωδικός',
      netAmount: 'Αξία χωρίς Φ.Π.Α.',
      vatPercentage: 'Κατηγορία Φ.Π.Α.',
      grossAmount: 'Τελική αξία',
      duration: 'Διάρκεια',
      status: 'Κατάσταση',
    },
    sections: {
      basicInfo: 'Βασικές πληροφορίες',
      amount: 'Αξία',
      duration: 'Διάρκεια',
      publicBooking: 'Online κρατήσεις',
    },
    fields: {
      name: 'Όνομα',
      category: 'Κατηγορία',
      status: 'Κατάσταση',
      netAmount: 'Αξία χωρίς Φ.Π.Α.',
      grossAmount: 'Αξία με Φ.Π.Α.',
      vatPercentage: 'Κατηγορία Φ.Π.Α. (%)',
      durationInMinutes: 'Διάρκεια υπηρεσίας (λεπτά)',
      preparationDurationInMinutes: 'Διάρκεια προετοιμασίας (λεπτά)',
      overlapAvailabilityDurationInMinutes: 'Χρόνος επικάλυψης διαθεσιμότητας (λεπτά)',
      bufferDurationInMinutes: 'Έξτρα χρόνος υπηρεσίας (λεπτά)',
      offeredForPublicBooking: 'Διαθέσιμη στις online κρατήσεις',
      comments: 'Παρατηρήσεις',
    },
    placeholders: {
      durationServiceExample: 'π.χ. 120',
      durationOtherExample: 'π.χ. 10',
    },
    tooltips: {
      durationService: 'Χρόνος που απαιτεί η διαδικασία σε λεπτά',
      preparation: 'Απαιτούμενος Χρόνος Προετοιμασίας πριν την έναρξη της διαδικασίας σε λεπτά',
      overlap: 'Χρόνος Παράλληλης Εξυπηρέτησης Πελατών σε λεπτά',
      buffer: 'Χρόνος Αναμονής Πελάτη σε λεπτά',
    },
    snackbars: {
      saved: 'Η υπηρεσία αποθηκεύτηκε επιτυχώς!',
      saveFailed: 'Η αποθήκευση της υπηρεσίας απέτυχε',
      notFound: 'Η υπηρεσία δεν βρέθηκε',
      reorderSuccess: 'Η σειρά ενημερώθηκε επιτυχώς',
    },
    validation: {
      nameRequired: 'Το όνομα της υπηρεσίας είναι υποχρεωτικό',
      vatInvalid: 'Η τιμή που επιλέξατε δεν είναι μέσα στις επιτρεπτές τιμές.',
      vatRequired: 'Το ποσοστό Φ.Π.Α. είναι υποχρεωτικό',
      durationPositive: 'Δεν επιτρέπεται αρνητική διάρκεια',
      durationMin: 'Η διάρκεια υπηρεσίας πρέπει να είναι τουλάχιστον 1 λεπτό',
      durationRequired: 'Η διάρκεια υπηρεσίας είναι υποχρεωτική',
      prepDurationMin: 'Η διάρκεια προετοιμασίας πρέπει να είναι τουλάχιστον 1 λεπτό',
      overlapMin: 'Τα λεπτά επικάλυψης πρέπει να είναι τουλάχιστον 1',
      bufferMin: 'Ο χρόνος αναμονής πρέπει να είναι τουλάχιστον 1 λεπτό',
    },
    reorder: {
      title: 'Αλλαγή σειράς εμφάνισης υπηρεσιών',
      description:
        'Προσαρμόστε τη σειρά εμφάνισης των υπηρεσιών στη σελίδα online κρατήσεων. Οι αλλαγές αποθηκεύονται αυτόματα και εφαρμόζονται άμεσα.',
      empty: 'Δεν υπάρχουν ακόμη καταχωρημένες υπηρεσίες',
    },
  },
  orders: {
    listTitle: 'Παραγγελίες',
    createOrder: 'Δημιουργία παραγγελίας',
    backToList: 'Λίστα Παραγγελιών',
    title: 'Παραγγελία',
    statusLabel: 'Κατάσταση παραγγελίας:',
    completeButton: 'Ολοκλήρωση',
    columns: {
      orderNumber: 'Αρ. παραγγελίας',
      createdAt: 'Ημ. δημιουργίας',
      lead: 'Lead',
      company: 'Εταιρεία',
      leadManager: 'Υπάλληλος (Lead Manager)',
      participants: 'Συμμετέχοντες',
      totalAmount: 'Αξία με ΦΠΑ',
      status: 'Κατάσταση παραγγελίας',
    },
    clone: {
      title: 'Αντιγραφή παραγγελίας',
      content: 'Θέλετε να αντιγράψετε την παραγγελία {{orderId}}?',
      success: 'Η παραγγελία {{orderId}} αντιγράφηκε επιτυχώς',
    },
    create: {
      title: 'Δημιουργία παραγγελίας',
      branch: 'Επιλογή υποκαταστήματος',
      allBranches: 'Όλα τα υποκαταστήματα',
      searchAccordion: 'Αναζήτηση επαφής{{ companyPart }}',
      companyPart: '/εταιρείας',
      contact: 'Επαφή',
      newContact: 'Δημιουργία νέας επαφής',
      mobilePhone: 'Κινητό τηλέφωνο',
      firstName: 'Όνομα',
      lastName: 'Επώνυμο',
      companyOrder: 'Εταιρική παραγγελία',
      contactCompany: 'Εταιρεία επαφής',
      snackbars: {
        contactExists: 'Η επαφή υπάρχει ήδη',
        contactCreateFailed: 'Η δημιουργία επαφής απέτυχε',
        saveFailed: 'Η αποθήκευση της παραγγελίας απέτυχε',
      },
    },
    sections: {
      basicInfo: 'Βασικές πληροφορίες',
      items: 'Είδη',
    },
    fields: {
      client: 'Πελάτης',
      company: 'Εταιρεία',
      effectiveFrom: 'Ημερομηνία δημιουργίας',
      expiresOn: 'Ημερομηνία λήξης',
      leadManager: 'Υπάλληλος (Lead Manager)',
      participants: 'Συμμετέχοντες',
      notes: 'Παρατηρήσεις',
      paymentMethod: 'Τρόπος πληρωμής:',
      totalDiscountAmount: 'Τελική έκπτωση (€):',
      totalDiscountPercentage: 'Τελική έκπτωση (%):',
      totalAmount: 'Τελικό σύνολο:',
    },
    items: {
      service: 'Υπηρεσία',
      netAmount: 'Αξία χωρίς ΦΠΑ',
      vat: 'ΦΠΑ',
      discountAmount: 'Έκπτωση €',
      discountPercentage: 'Έκπτωση %',
      total: 'Σύνολο',
    },
    selectPaymentMethod: 'Επιλέξτε τρόπο πληρωμής',
    snackbars: {
      updated: 'Η παραγγελία ενημερώθηκε',
      itemAdded: 'Η υπηρεσία προστέθηκε',
      itemDeleted: 'Η υπηρεσία διαγράφηκε',
      saveFailed: 'Η αποθήκευση της παραγγελίας απέτυχε',
      genericFail: 'Κάτι πήγε στραβά.',
      notFound: 'Η παραγγελία δεν βρέθηκε',
    },
    delete: {
      title: 'Διαγραφή παραγγελίας',
      content: 'Θέλετε να διαγράψετε την παραγγελία #{{orderId}}?',
    },
    validation: {
      totalDiscountRequired: 'Η συνολική έκπτωση είναι υποχρεωτική',
      totalAmountRequired: 'Το συνολικό ποσό είναι υποχρεωτικό',
      currencyInvalid: 'Η τιμή που επιλέξατε δεν είναι μέσα στις επιτρεπτές τιμές.',
      serviceRequired: 'Η υπηρεσία είναι υποχρεωτική',
      netAmountRequired: 'Η Αξία χωρίς ΦΠΑ είναι υποχρεωτική',
      vatPercentageRequired: 'Η Κατηγορία ΦΠΑ είναι υποχρεωτική',
      itemTotalRequired: 'Το σύνολο είναι υποχρεωτικό',
      statusRequired: 'Η κατάσταση της παραγγελίας είναι υποχρεωτική',
      effectiveFromRequired: 'Η ημερομηνία δημιουργίας είναι υποχρεωτική',
      clientRequired: 'Η επιλογή πελάτη είναι υποχρεωτική',
      atLeastOneItem: 'Η παραγγελία πρέπει να έχει τουλάχιστον μια υπηρεσία',
      mobileRequired: 'Το κινητό είναι υποχρεωτικό',
      mobileInvalid: 'Το κινητό δεν είναι έγκυρο',
      grossTotalMax: 'Το σύνολο δεν πρέπει να ξεπερνά τα {{max}}€',
    },
  },
  bookings: {
    calendarTitle: 'Ημερολόγιο',
    listTitle: 'Ραντεβού',
    backToCalendar: 'Ημερολόγιο',
    columns: {
      contact: 'Πελάτης',
      dateTime: 'Ημερομηνία/Ώρα',
      service: 'Υπηρεσία',
      amount: 'Αξία',
      employee: 'Υπάλληλος',
      status: 'Κατάσταση ραντεβού',
    },
    delete: {
      title: 'Διαγραφή παραγγελίας',
      content: 'Θέλετε να διαγράψετε το ραντεβού {{bookingId}}?',
    },
    toolbar: {
      list: 'Λίστα ραντεβού',
      newBooking: 'Νέο ραντεβού',
      today: 'Σήμερα',
      filters: 'Φίλτρα',
      filtersLabel: 'Φίλτρα:',
      filtersTitle: 'Φίλτρα ραντεβού',
      apply: 'Εφαρμογή',
      filterChip: {
        contact: 'Πελάτης: {{name}}',
        service: 'Υπηρεσία: {{name}}',
        status: 'Κατάσταση: {{name}}',
      },
    },
    drawer: {
      service: 'Υπηρεσία',
      contact: 'Πελάτης',
      status: 'Κατάσταση ραντεβού',
    },
    validation: {
      dateRequired: 'Η ημερομηνία είναι υποχρεωτική',
      timeRequired: 'Η ώρα είναι υποχρεωτική',
      employeeRequired: 'Η επιλογή υπαλλήλου είναι υποχρεωτική',
      firstNameRequired: 'Το όνομα είναι υποχρεωτικό',
      mobileRequired: 'Το κινητό είναι υποχρεωτικό',
      mobileInvalid: 'Το κινητό δεν είναι έγκυρο',
      serviceRequired: 'Η επιλογή υπηρεσίας είναι υποχρεωτική',
    },
    snackbars: {
      created: 'Το ραντεβού δημιουργήθηκε',
      updated: 'Το ραντεβού ενημερώθηκε',
      deleted: 'Το ραντεβού διαγράφηκε',
      saved: 'Το ραντεβού αποθηκεύτηκε.',
      cancelled: 'Το ραντεβού ακυρώθηκε.',
      saveFailed: 'Κάτι πήγε στραβά.',
      notFound: 'Η κράτηση δεν βρέθηκε',
      mobileCheckFailed: 'Κάτι πήγε στραβά κατά τον έλεγχο του κινητού',
      contactCreateFailed: 'Η δημιουργία επαφής απέτυχε',
      pickContactWarning: 'Επιλέξτε υπάρχουσα επαφή ή δημιουργήστε νέα.',
    },
    form: {
      backToList: 'Λίστα Ραντεβού',
      titleEdit: 'Επεξεργασία Ραντεβού',
      titleNew: 'Νέο Ραντεβού',
      statusPlaceholder: 'Κατάσταση ραντεβού',
      statusLabel: 'Κατάσταση ραντεβού',
      completedAlert: 'To ραντεβού είναι ολοκληρωμένο. Για να το επεξεργαστείτε θα πρέπει να αλλάξετε το status της συνδεδεμένης',
      completedAlertLink: 'παραγγελίας',
      date: 'Ημερομηνία',
      time: 'Ώρα',
      employee: 'Υπάλληλος',
      service: 'Υπηρεσία',
      comments: 'Σχόλια',
      searchExistingContact: 'Αναζήτηση υπάρχουσας επαφής',
      newContactSection: 'Δημιουργία νέας επαφής',
      mobilePhone: 'Κινητό τηλέφωνο',
      firstName: 'Όνομα',
      lastName: 'Επώνυμο',
      notifyClient: 'Ειδοποίηση πελάτη',
      notifyClientTooltip:
        "Αν ενεργοποιήσετε την ειδοποίηση πελάτη, κατά την μετάβαση του ραντεβου στην κατάσταση 'Σε Ισχύ' ή κατά την ακύρωση, θα αποσταλεί email με τις λεπτομέρειες του ραντεβού στον πελάτη.",
      save: 'Αποθήκευση',
      create: 'Δημιουργία',
      cancelButton: 'Ακύρωση',
      cancelBooking: 'Ακύρωση ραντεβού',
      cancelDialogTitle: 'Ακύρωση ραντεβού',
      cancelDialogContent: 'Θέλετε σίγουρα να ακυρώσετε αυτό το ραντεβού;',
    },
  },
  statistics: {
    title: 'Στατιστικά',
    totalRevenue: 'Συνολικός Τζίρος',
    monthlyRevenue: 'Μηνιαίος Τζίρος',
    compareLastYear: 'Σε σχέση με πέρσι το ίδιο διάστημα',
    noData: 'Δεν υπάρχουν δεδομένα',
    revenueByMonth: 'Τζίρος ανά Μήνα',
    revenueByService: 'Τζίρος ανά Υπηρεσία',
    revenueByServiceCategory: 'Τζίρος ανά Κατηγορία Υπηρεσιών',
    revenueByEmployee: 'Τζίρος ανά Υπάλληλο',
    revenueByEmployeeService: 'Τζίρος ανά Υπάλληλο ανά Υπηρεσία',
    completedOnlyTooltip: 'Μόνο για ολοκληρωμένες παραγγελίες',
    dateRange: {
      start: 'Από',
      end: 'Έως',
    },
  },
  dashboard: {
    listTitle: 'Επισκόπηση',
    period: {
      label: 'Χρονική περίοδος',
      last7: 'Τελευταίες 7 ημέρες',
      last30: 'Τελευταίες 30 ημέρες',
      last365: 'Τελευταίες 365 ημέρες',
    },
    activeClients: {
      title: 'Ενεργοί Πελάτες',
      tooltip: 'Οι πελάτες σας που έχουν ολοκληρωμένες παραγγελίες',
    },
    noShow: {
      title: 'No Show Ratio',
      tooltip:
        'Το ratio %NSA (ποσοστό No Show Appointments) είναι ένας δείκτης που μετρά το ποσοστό των προγραμματισμένων ραντεβού που δεν πραγματοποιήθηκαν επειδή ο πελάτης δεν προσήλθε, χωρίς να έχει ακυρώσει το ραντεβού του.',
    },
    availableEmployees: {
      title: 'Διαθέσιμοι σήμερα',
      empty: 'Κανένας διαθέσιμος υπάλληλος.',
    },
    nextAppointments: {
      title: 'Επόμενα ραντεβού ημέρας',
      empty: 'Δεν υπάρχουν ραντεβού για σήμερα.',
      defaultService: 'Υπηρεσία',
      with: 'με {{name}}',
    },
    pendingAppointments: {
      title: 'Μη επιβεβαιωμένα ραντεβού',
      empty: 'Δεν υπάρχουν Μη Επιβεβαιωμένα Ραντεβού',
      confirmTooltip: 'Επιβεβαίωση ραντεβού',
      cancelTooltip: 'Ακύρωση ραντεβού',
      openTooltip: 'Άνοιγμα ραντεβού',
      confirmedSnackbar: 'Το ραντεβού επιβεβαιώθηκε.',
      cancelledSnackbar: 'Το ραντεβού ακυρώθηκε.',
      confirmFailed: 'Αποτυχία επιβεβαίωσης ραντεβού',
      cancelFailed: 'Αποτυχία ακύρωσης ραντεβού',
    },
    topClients: {
      title: 'Τοπ 10 πελάτες',
      empty: 'Δεν υπάρχουν δεδομένα',
      loadFailed: 'Αποτυχία φόρτωσης πελατών',
      sortVisits: 'Επισκέψεις',
      sortPayments: 'Πληρωμές',
    },
    topServices: {
      title: 'Τοπ 10 υπηρεσίες',
      empty: 'Δεν υπάρχουν δεδομένα',
      loadFailed: 'Αποτυχία φόρτωσης υπηρεσιών',
      sortCount: 'Ποσότητα',
      sortCost: 'Τζίρος',
    },
  },
  apiErrors: {
    erganiInvalidCredentials: 'Λάθος username ή password για την ΕΡΓΑΝΗ',
    erganiUnavailable: 'Η ΕΡΓΑΝΗ δεν είναι διαθέσιμη αυτή τη στιγμή. Δοκιμάστε ξανά αργότερα.',
    activeBranchLimitReached:
      'Έχετε φτάσει το μέγιστο αριθμό ενεργών καταστημάτων ({{branchLimit}}). Επικοινωνήστε μαζί μας για αναβάθμιση.',
    activeEmployeeLimitReachedForTier:
      "Έχετε φτάσει το όριο ενεργών εργαζομένων για το πακέτο '{{tierCode}}' ({{employeeLimit}}). Αναβαθμίστε το πακέτο σας.",
  },
  validation: {
    money: {
      amountInvalid: 'Παρακαλώ εισάγετε έναν έγκυρο αριθμό',
      amountRequired: 'Το ποσό είναι υποχρεωτικό',
      amountNonNegative: 'Δεν επιτρέπονται αρνητικές τιμές',
      currencyRequired: 'Το νόμισμα είναι υποχρεωτικό',
    },
    logo: {
      fileRequired: 'Παρακαλώ επιλέξτε ένα αρχείο',
      fileSizeMax: 'Το μέγεθος του αρχείου δεν πρέπει να υπερβαίνει τα {{max}}MB',
      fileTypeImage: 'Το αρχείο πρέπει να είναι PNG ή JPEG',
      fileExtensionInvalid: 'Μη έγκυρη επέκταση αρχείου',
      extensionInvalidWithFile: 'Μη έγκυρη επέκταση αρχείου: {{ext}}. Επιτρεπόμενα: .png, .jpg, .jpeg',
      typeInvalid: 'Μη έγκυρος τύπος αρχείου',
      sizeMaxWithCurrent: 'Το μέγεθος του αρχείου δεν πρέπει να υπερβαίνει τα 5MB (τρέχον: {{size}}MB)',
      imageTooSmall: 'Η εικόνα είναι πολύ μικρή: {{width}}×{{height}}px (ελάχιστο: {{min}}px στη μικρότερη πλευρά)',
      imageTooLarge: 'Η εικόνα είναι πολύ μεγάλη: {{width}}×{{height}}px (μέγιστο: {{max}}px στη μεγαλύτερη πλευρά)',
      invalidImageFile: 'Μη έγκυρο αρχείο εικόνας',
      readError: 'Σφάλμα κατά την ανάγνωση της εικόνας',
      qualityExcellent: 'Εξαιρετική ποιότητα',
      qualityGood: 'Καλή ποιότητα',
      qualityAcceptable: 'Αποδεκτή ποιότητα (συνιστάται υψηλότερη ανάλυση)',
      uploaded: 'Το λογότυπο ανέβηκε με επιτυχία',
      uploadFailed: 'Αποτυχία ανεβάσματος. Παρακαλώ δοκιμάστε ξανά.',
    },
  },
  filters: {
    selected_one: '{{count}} επιλεγμένο',
    selected_other: '{{count}} επιλεγμένα',
    dateRangePlaceholder: 'Από - Εώς',
    lastOrder: {
      placeholder: 'Από - Εώς/Κατάσταση',
      date: 'Ημερομηνία',
      status: 'Κατάσταση',
      all: 'Όλες',
    },
  },
  settings: {
    listTitle: 'Ρυθμίσεις',
    tabs: {
      publicBooking: 'Online κρατήσεις',
      serviceGroups: 'Ειδικότητες',
      acquisitionSources: 'Πού μας βρήκατε',
      orderStatuses: 'Καταστάσεις παραγγελίας',
      ergani: 'ΕΡΓΑΝΗ',
      serviceCategories: 'Κατηγορίες υπηρεσιών',
      branches: 'Καταστήματα',
      companies: 'Οι εταιρείες μου',
      invoicing: 'Τιμολόγια',
    },
    item: {
      available: 'Ενεργό',
      unavailable: 'Μη ενεργό',
    },
    tenants: {
      title: 'Tenants',
      addButton: 'Προσθήκη tenant',
      empty: 'Δεν βρέθηκαν tenants',
      modalTitleAdd: 'Προσθήκη tenant',
      modalTitleEdit: 'Επεξεργασία tenant',
      featurePlaceholder: 'Επιλογή features',
      fields: {
        name: 'Όνομα',
        alias: 'Alias',
        tier: 'Tier',
        features: 'Features',
        firstName: 'Όνομα Tenant Admin',
        lastName: 'Επώνυμο',
        email: 'Email',
        platformAdminEmail: 'Platform Admin Email',
      },
      validation: {
        nameRequired: 'Το όνομα είναι υποχρεωτικό',
        aliasRequired: 'Το alias είναι υποχρεωτικό',
        tierRequired: 'Το tier είναι υποχρεωτικό',
        firstNameRequired: 'Το όνομα είναι υποχρεωτικό',
        lastNameRequired: 'Το επώνυμο είναι υποχρεωτικό',
        emailInvalid: 'Μη έγκυρο email',
        emailRequired: 'Το email είναι υποχρεωτικό',
      },
      snackbars: {
        created: 'O tenant δημιουργήθηκε επιτυχώς!',
        createFailed: 'Η δημιουργία του tenant απέτυχε',
        updated: 'Ο tenant ενημερώθηκε επιτυχώς!',
        updateFailed: 'Η ενημέρωση του tenant απέτυχε',
        copied: 'Αντιγράφηκε!',
      },
      buttons: {
        cancel: 'Ακύρωση',
        save: 'Αποθήκευση',
      },
      onboardResult: {
        title: 'Tenant δημιουργήθηκε',
        warning: 'Οι κωδικοί δεν θα εμφανιστούν ξανά μετά το κλείσιμο αυτού του παραθύρου. Σημειώστε τους πριν συνεχίσετε.',
        tenantPasswordLabel: 'Κωδικός διαχειριστή tenant',
        platformPasswordLabel: 'Κωδικός διαχειριστή πλατφόρμας',
        clickHere: 'Click Here',
        show: 'Εμφάνιση',
        hide: 'Απόκρυψη',
        copy: 'Αντιγραφή',
        close: 'Κλείσιμο',
      },
    },
    publicBooking: {
      title: 'Online κρατήσεις',
      branding: {
        title: 'Branding Εταιρείας',
      },
      nameForm: {
        label: 'Επωνυμία εταιρείας',
        helperText: 'Το όνομα που θα εμφανίζεται στους πελάτες κατά την online κράτηση',
        placeholder: 'Εισάγετε το όνομα',
        charactersHelper: '{{count}}/{{max}} χαρακτήρες:',
        save: 'Αποθήκευση',
        updated: 'Το όνομα ενημερώθηκε επιτυχώς',
        saveError: 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση',
      },
      logoUpload: {
        title: 'Ανέβασμα νέου λογότυπου',
        formats: 'Αποδεκτές μορφές: PNG, JPEG • Μέγιστο μέγεθος: 5MB • Διαστάσεις: 100-3000px',
        chooseFile: 'Επιλογή Αρχείου',
        clear: 'Καθαρισμός',
        publish: 'Δημοσίευση',
      },
      logoPreview: {
        defaultCompany: 'Εταιρεία',
        currentTitle: 'Τρέχον Λογότυπο',
        previewTitle: 'Προεπισκόπηση',
        previewBadge: 'Προεπισκόπηση',
        previewLogoAlt: 'Προεπισκόπηση λογότυπου',
        companyLogoAlt: '{{name}} λογότυπο',
        howItWillAppear: 'Έτσι θα εμφανίζεται το λογότυπό σας στη σελίδα κρατήσεων',
        emptyPreview: 'Δεν έχει επιλεγεί αρχείο',
        emptyCurrent: 'Δεν έχει ανέβει λογότυπο',
        urlNote: 'Σημείωση: Τα URLs λήγουν μετά από 10 λεπτά και ανανεώνονται αυτόματα',
      },
      bookingSummary: {
        previewTitle: 'Προεπισκόπηση σελίδας κρατήσεων',
        previewBadge: 'Προεπισκόπηση',
        howItWillAppear: 'Έτσι θα εμφανίζεται το λογότυπό σας στη σελίδα κρατήσεων',
        servicesTitle: 'Επιλεγμένες Υπηρεσίες',
        durationOneHour: '1 ώρα',
        totalCost: 'Συνολικό Κόστος',
        sampleService: 'Κούρεμα χτένισμα',
      },
      wizardSteps: {
        title: 'Βήματα κράτησης',
        description: 'Ρυθμίστε ποια βήματα θα εμφανίζονται στη σελίδα online κρατήσεων.',
        showEmployeeLabel: 'Εμφάνιση επιλογής υπαλλήλου',
        showEmployeeHelper: 'Όταν είναι ενεργοποιημένο, οι πελάτες μπορούν να επιλέξουν συγκεκριμένο υπάλληλο κατά την κράτηση.',
        emailRequiredLabel: 'Υποχρεωτικό email πελάτη',
        emailRequiredHelper:
          'Όταν είναι απενεργοποιημένο, οι πελάτες μπορούν να κάνουν κράτηση χωρίς email. Τα ραντεβού χωρίς email δεν θα λαμβάνουν email επιβεβαίωσης και θα παραμένουν σε κατάσταση αναμονής.',
        loadFailed: 'Αποτυχία φόρτωσης ρυθμίσεων',
        savedSuccess: 'Οι ρυθμίσεις αποθηκεύτηκαν επιτυχώς',
        saveFailed: 'Αποτυχία αποθήκευσης ρυθμίσεων',
      },
      ownerNotifications: {
        title: 'Ειδοποιήσεις καταστηματάρχη',
        description:
          'Λάβετε email όταν ένας πελάτης κάνει κράτηση από τη σελίδα online κρατήσεων. Δεν ισχύει για κρατήσεις από το back office.',
        enableLabel: 'Αποστολή ειδοποιήσεων νέων ραντεβού',
        enableHelper:
          'Λάβετε email όταν ένας πελάτης κλείνει ραντεβού από τις online κρατήσεις. Δεν ισχύει για ραντεβού από το back office.',
        onlyConfirmedLabel: 'Μόνο για επιβεβαιωμένα ραντεβού',
        onlyConfirmedHelper:
          'Όταν είναι ενεργό, λαμβάνετε email μόνο όταν ο πελάτης επιβεβαιώσει το ραντεβού. Απενεργοποιήστε το για να ειδοποιείστε και για τα εκκρεμή (μη επιβεβαιωμένα) ραντεβού.',
        recipientEmailLabel: 'Email παραλήπτη',
        recipientEmailPlaceholder: 'Εισάγετε email',
        recipientEmailHelper: 'Η διεύθυνση στην οποία θα στέλνονται οι ειδοποιήσεις.',
        emailRequired: 'Το email είναι υποχρεωτικό όταν είναι ενεργή μια ειδοποίηση',
        emailInvalid: 'Η διεύθυνση email δεν είναι έγκυρη',
        save: 'Αποθήκευση',
        savedSuccess: 'Οι ρυθμίσεις αποθηκεύτηκαν επιτυχώς',
        saveFailed: 'Αποτυχία αποθήκευσης ρυθμίσεων',
        loadFailed: 'Αποτυχία φόρτωσης ρυθμίσεων',
      },
    },
    ergani: {
      reconnectTitle: 'Επανασύνδεση με ΕΡΓΑΝΗ',
      initialTitle: 'Στοιχεία σύνδεσης επιχείρησης',
      businessDetailsTitle: 'Στοιχεία επιχείρησης',
      branchesTitle: 'Παραρτήματα',
      successChip: 'Επιτυχής σύνδεση με Εργάνη',
      disconnectButton: 'Αποσύνδεση',
      disconnectDialog: {
        title: 'Αποσύνδεση',
        content: 'Είστε σίγουροι ότι θέλετε να αποσυνδέσετε τον λογαριασμό της Εργάνης;',
        confirm: 'Αποσύνδεση',
      },
      reconnectButton: 'Σύνδεση με νέα στοιχεία',
      saveButton: 'Αποθήκευση',
      cancelButton: 'Ακύρωση',
      connectButton: 'Σύνδεση',
      fields: {
        username: 'Username',
        password: 'Password',
        companyName: 'Επωνυμία',
        taxId: 'ΑΦΜ',
        erganiBranch: 'Παράρτημα',
        connectedStore: 'Συνδεδεμένο με κατάστημα',
        selectStore: 'Επιλέξτε',
      },
      snackbars: {
        connected: 'Η σύνδεση με την ΕΡΓΑΝΗ ολοκληρώθηκε επιτυχώς!',
        connectFailed: 'Η σύνδεση με την ΕΡΓΑΝΗ απέτυχε',
        settingsSaved: 'Οι ρυθμίσεις αποθηκεύτηκαν επιτυχώς!',
        settingsSaveFailed: 'Αποτυχία αποθήκευσης ρυθμίσεων',
        loadFailed: 'Αποτυχία φόρτωσης στοιχείων ΕΡΓΑΝΗ',
      },
      validation: {
        usernameRequired: 'Το username είναι υποχρεωτικό',
        passwordRequired: 'Ο κωδικός είναι υποχρεωτικός',
        storeIdRequired: 'Ο αριθμός είναι υποχρεωτικός',
      },
    },
    serviceCategories: {
      title: 'Κατηγορίες υπηρεσιών',
      addButton: 'Προσθήκη νέας κατηγορίας',
      reorderButton: 'Αλλαγή σειράς εμφάνισης',
      empty: 'Δεν βρέθηκαν κατηγορίες υπηρεσιών',
      tabHeading: 'Υπηρεσίες εντός της κατηγορίας {{name}}',
      tabEmpty: 'Δεν υπάρχουν υπηρεσίες σε αυτήν την κατηγορία',
      inactiveChip: 'Ανενεργή',
      editAction: 'Επεξεργασία',
      modalTitleEdit: 'Επεξεργασία κατηγορίας',
      modalTitleAdd: 'Προσθήκη κατηγορίας',
      fields: {
        name: 'Όνομα κατηγορίας',
        services: 'Υπηρεσίες',
        servicePlaceholder: 'Επιλογή υπηρεσίας',
      },
      validation: {
        nameRequired: 'Το όνομα της κατηγορίας είναι υποχρεωτικό',
        nameDuplicate: 'Υπάρχει ήδη κατηγορία με αυτό το όνομα',
      },
      snackbars: {
        saved: 'Η κατηγορία αποθηκεύτηκε επιτυχώς!',
        updated: 'Η κατηγορία ενημερώθηκε επιτυχώς!',
        deleted: 'Η κατηγορία διαγράφτηκε επιτυχώς!',
        saveFailed: 'Η αποθήκευση της κατηγορίας απέτυχε',
        updateFailed: 'Η ενημέρωση της κατηγορίας απέτυχε',
        deleteFailed: 'Η διαγραφή της κατηγορίας απέτυχε',
        reorderSuccess: 'Η σειρά ενημερώθηκε επιτυχώς',
      },
      deleteDialog: {
        title: 'Επιβεβαίωση διαγραφής',
        content: 'Θέλετε σίγουρα να διαγραφεί η κατηγορία {{name}}?',
        confirm: 'Διαγραφή',
      },
      reorder: {
        title: 'Αλλαγή σειράς εμφάνισης κατηγοριών',
        description: 'Προσαρμόστε τη σειρά εμφάνισης των κατηγοριών υπηρεσιών. Οι αλλαγές αποθηκεύονται αυτόματα και εφαρμόζονται άμεσα.',
        empty: 'Δεν υπάρχουν ακόμη καταχωρημένες κατηγορίες',
        close: 'Κλείσιμο',
      },
      services_one: '{{count}} υπηρεσία',
      services_other: '{{count}} υπηρεσίες',
      buttons: {
        cancel: 'Ακύρωση',
        save: 'Αποθήκευση',
        create: 'Δημιουργία',
      },
    },
    orderStatuses: {
      title: 'Καταστάσεις παραγγελίας',
      defaultLabel: 'Προεπιλεγμένη κατάσταση παραγγελίας',
      orderTitle: 'Σειρά καταστάσεων παραγγελίας',
      active: 'Ενεργή',
      inactive: 'Ανενεργή',
      snackbars: {
        updated: 'To status ενημερώθηκε επιτυχώς',
        updateFailed: 'Κάτι πήγε στραβά.',
      },
    },
    acquisitionSources: {
      title: 'Που μας βρήκατε',
      addButton: 'Προσθήκη πηγής',
      empty: 'Δεν βρέθηκαν πηγές',
      modalTitleEdit: 'Επεξεργασία πηγής',
      modalTitleAdd: 'Προσθήκη πηγής',
      fields: {
        name: 'Πηγή',
      },
      validation: {
        nameRequired: 'Η πηγή είναι υποχρεωτική',
      },
      snackbars: {
        saved: 'Η πηγή αποθηκεύτηκε επιτυχώς!',
        updated: 'Η πηγή ενημερώθηκε επιτυχώς!',
        deleted: 'Η πηγή διαγράφηκε επιτυχώς!',
        saveFailed: 'Η αποθήκευση της πηγής απέτυχε',
        updateFailed: 'Η ενημέρωση της πηγής απέτυχε',
        deleteFailed: 'Η διαγραφή της πηγής απέτυχε',
        enableFailed: 'Η ενεργοποίηση της πηγής απέτυχε',
        disableFailed: 'Η απενεργοποίηση της πηγής απέτυχε',
      },
      deleteDialog: {
        title: 'Επιβεβαίωση διαγραφής',
        content: 'Θέλετε σίγουρα να διαγραφεί αυτή η πηγή {{name}}?',
        confirm: 'Διαγραφή',
      },
      buttons: {
        cancel: 'Ακύρωση',
        save: 'Αποθήκευση',
        create: 'Δημιουργία',
      },
    },
    serviceGroups: {
      title: 'Ειδικότητες',
      addButton: 'Προσθήκη ειδικότητας',
      empty: 'Δεν βρέθηκαν ειδικότητες',
      modalTitleEdit: 'Επεξεργασία ειδικότητας',
      modalTitleAdd: 'Προσθήκη ειδικότητας',
      fields: {
        name: 'Όνομα ειδικότητας',
        services: 'Υπηρεσίες',
        servicePlaceholder: 'Επιλογή υπηρεσίας',
      },
      validation: {
        nameRequired: 'Το όνομα είναι υποχρεωτικό',
        servicesRequired: 'Πρέπει να επιλέξετε τουλάχιστον 1 υπηρεσία',
      },
      snackbars: {
        saved: 'Η ειδικότητα αποθηκεύτηκε επιτυχώς!',
        updated: 'Η ειδικότητα ενημερώθηκε επιτυχώς!',
        deleted: 'Η ειδικότητα διαγράφτηκε επιτυχώς!',
        saveFailed: 'Η αποθήκευση της ειδικότητας απέτυχε',
        updateFailed: 'Η ενημέρωση της ειδικότητας απέτυχε',
        deleteFailed: 'Η διαγραφή της ειδικότητας απέτυχε',
        enableFailed: 'Η ενεργοποίηση της ειδικότητας απέτυχε',
        disableFailed: 'Η απενεργοποίηση της ειδικότητας απέτυχε',
      },
      deleteDialog: {
        title: 'Επιβεβαίωση διαγραφής',
        content: 'Θέλετε σίγουρα να διαγραφεί η ειδικότητα {{name}}?',
        confirm: 'Διαγραφή',
      },
      buttons: {
        cancel: 'Ακύρωση',
        save: 'Αποθήκευση',
        create: 'Δημιουργία',
      },
    },
    branches: {
      title: 'Καταστήματα',
      addButton: 'Προσθήκη καταστήματος',
      addButtonDisabledTooltip: 'Έχετε φτάσει το μέγιστο αριθμό καταστημάτων. Επικοινωνήστε μαζί μας για αναβάθμιση.',
      empty: 'Δεν βρέθηκαν καταστήματα',
      modalTitleEdit: 'Επεξεργασία καταστήματος',
      modalTitleAdd: 'Προσθήκη καταστήματος',
      linkedCompany: 'Συνδεμένη εταιρεία',
      noCompanyWarning: 'Αυτό το κατάστημα δεν έχει συνδεδεμένη εταιρεία για να μπορέσει να εκδίδει τιμολόγια.',
      addCompany: 'Προσθήκη εταιρείας',
      fields: {
        name: 'Όνομα καταστήματος',
        address: 'Διεύθυνση',
        linkToCompany: 'Σύνδεση με εταιρεία μου',
      },
      validation: {
        nameRequired: 'Το όνομα καταστήματος είναι υποχρεωτικό',
        addressRequired: 'Η διεύθυνση είναι υποχρεωτική',
      },
      snackbars: {
        saved: 'Το κατάστημα αποθηκεύτηκε επιτυχώς!',
        updated: 'Το κατάστημα ενημερώθηκε επιτυχώς!',
        deleted: 'Το κατάστημα διαγράφηκε επιτυχώς!',
        saveFailed: 'Η αποθήκευση του καταστήματος απέτυχε',
        updateFailed: 'Η ενημέρωση του καταστήματος απέτυχε',
        deleteFailed: 'Η διαγραφή του καταστήματος απέτυχε',
        enableFailed: 'Η ενεργοποίηση του καταστήματος απέτυχε',
        disableFailed: 'Η απενεργοποίηση του καταστήματος απέτυχε',
      },
      deleteDialog: {
        title: 'Επιβεβαίωση διαγραφής',
        content: 'Θέλετε σίγουρα να διαγραφεί το κατάστημα "{{name}}";',
        confirm: 'Διαγραφή',
      },
      buttons: {
        cancel: 'Ακύρωση',
        save: 'Αποθήκευση',
        create: 'Δημιουργία',
      },
    },
    invoicing: {
      title: 'Τιμολόγια',
      sectionTitle: 'Σειρές αρίθμησης',
      addButton: 'Προσθήκη σειράς',
      empty: 'Δεν έχετε σειρές αρίθμησης.\nΠατήστε "Προσθήκη σειράς" για να δημιουργήσετε μια σειρά.',
      modalTitleAdd: 'Προσθήκη σειράς',
      modalTitleEdit: 'Τροποποίηση σειράς',
      fields: {
        name: 'Όνομα σειράς',
      },
      helperTexts: {
        editWarning: 'Όλες οι εγγραφές που χρησιμοποιούν τη σειρά θα επηρεαστούν από τις αλλαγές.',
      },
      validation: {
        nameRequired: 'Το όνομα σειράς είναι υποχρεωτικό',
      },
      item: {
        notUsed: 'Δεν χρησιμοποιείται ακόμα',
        usedInRecords_one: 'Χρησιμοποιείται σε {{count}} εγγραφή',
        usedInRecords_other: 'Χρησιμοποιείται σε {{count}} εγγραφές',
        defaultChip: 'Προεπιλεγμένη',
        active: 'Ενεργή',
      },
      tooltips: {
        defaultChip: 'Είναι η σειρά που εμφανίζεται ως προεπιλεγμένη κάθε φορά που δημιουργείται ένα παραστατικό τιμολογίου.',
        cannotEdit:
          'Δε μπορείτε να αλλάξετε την ονομασία της σειράς, γιατί υπάρχουν ένα ή περισσότερα παραστατικά με αυτή τη σειρά που έχουν αποσταλεί στο myDATA.',
        cannotDeactivateDefault: 'Για να απενεργοποιήσετε αυτή τη σειρά, επιλέξτε πρώτα μια άλλη ως προεπιλεγμένη.',
      },
      snackbars: {
        created: 'Η σειρά δημιουργήθηκε επιτυχώς!',
        updated: 'Η σειρά ενημερώθηκε επιτυχώς!',
        defaultSet: 'Η σειρά ορίστηκε ως προεπιλεγμένη!',
        deactivated: 'Η σειρά απενεργοποιήθηκε επιτυχώς!',
        activated: 'Η σειρά ενεργοποιήθηκε επιτυχώς!',
        createFailed: 'Η δημιουργία της σειράς απέτυχε',
        updateFailed: 'Η ενημέρωση της σειράς απέτυχε',
        defaultFailed: 'Η αλλαγή προεπιλεγμένης σειράς απέτυχε',
        toggleFailed: 'Η αλλαγή κατάστασης της σειράς απέτυχε',
      },
      buttons: {
        cancel: 'Ακύρωση',
        save: 'Αποθήκευση',
        create: 'Δημιουργία',
      },
    },
  },
  companies: {
    listTitle: 'Εταιρείες',
    addCompany: 'Προσθήκη εταιρείας',
    backToList: 'Λίστα εταιρειών',
    empty: 'Δεν βρέθηκαν εταιρείες',
    columns: {
      taxId: 'ΑΦΜ',
      legalName: 'Επωνυμία',
      registeredAddress: 'Διεύθυνση',
      tradeName: 'Δραστηριότητα',
      companyType: 'Τύπος εταιρείας',
      country: 'Χώρα',
    },
    fields: {
      taxId: 'ΑΦΜ',
      legalName: 'Επωνυμία',
      registeredAddressVies: 'Διεύθυνση VIES',
      address: 'Διεύθυνση',
      country: 'Χώρα',
      activity: 'Δραστηριότητα',
      companyType: 'Τύπος εταιρείας',
      tradeName: 'Διακριτικός τίτλος',
      location: 'Τοποθεσία',
    },
    sections: {
      basicInfo: 'Βασικές πληροφορίες',
      linkedContacts: 'Συνδεδεμένες επαφές',
    },
    contactColumns: {
      lastName: 'Επώνυμο',
      firstName: 'Όνομα',
      role: 'Ρόλος',
    },
    actions: {
      linkContact: 'Σύνδεση επαφής',
      updateViaVies: 'Ενημέρωση μέσω VIES',
      lastUpdated: 'Τελευταία ενημέρωση: {{date}}',
      viaVies: 'μέσω VIES',
    },
    search: {
      mobilePlaceholder: 'Όνομα, ΑΦΜ, Χώρα',
    },
    tabs: {
      details: 'Στοιχεία',
      contacts: 'Επαφές',
    },
    addModal: {
      searchTitle: 'Αναζήτηση σε VIES/TaxisNet',
      detailsTitle: 'Στοιχεία εταιρείας από VIES/TaxisNet',
      manualTitle: 'Προσθήκη εταιρείας',
      manualEntry: 'Χειροκίνητη προσθήκη',
      newSearch: 'Νέα Αναζήτηση',
    },
    unlinkContact: {
      title: 'Αφαίρεση επαφής από την εταιρεία',
      content: 'Θέλετε να αφαιρέσετε την επαφή {{contactName}} από την εταιρεία {{companyName}}?',
      confirm: 'Αφαίρεση',
    },
    snackbars: {
      notFound: 'Η εταιρεία δεν βρέθηκε',
      updated: 'Η εταιρεία ενημερώθηκε',
      saved: 'Η εταιρεία αποθηκεύτηκε επιτυχώς!',
      contactLinked: 'Η επαφή συνδέθηκε με την εταιρεία',
      contactUnlinked: 'Η επαφή αφαιρέθηκε από την εταιρεία',
      taxIdAlreadyExists: 'Η εταιρεία με το παρόν ΑΦΜ έχει ήδη καταχωρηθεί',
      viesNotActive: 'Το παρόν ΑΦΜ δεν είναι ενεργό στο VIES',
      viesCredentialsInvalid: 'Τα στοιχεία σύνδεσης δεν είναι σωστά',
      viesUnavailable: 'Η υπηρεσία VIES δεν είναι διαθέσιμη',
    },
    validation: {
      taxIdRequired: 'Το ΑΦΜ είναι υποχρεωτικό',
      countryRequired: 'Η χώρα είναι υποχρεωτική',
      legalNameRequired: 'Η επωνυμία είναι υποχρεωτική',
      activityRequired: 'Η δραστηριότητα είναι υποχρεωτική',
      addressRequired: 'Η διεύθυνση είναι υποχρεωτική',
      companyTypeRequired: 'Ο τύπος εταιρείας είναι υποχρεωτικός',
    },
  },
};

export default el;
